import Hotspot from './Hotspot'

export default class HotspotsHandler {
    constructor(container) {
        this.hotspotElements = []
        this.currentHotspot = null

        // init hotspots
        container.querySelectorAll('.js-hotspot').forEach((element) => this.hotspotElements.push(new Hotspot(element)))

        // add handler
        this.addToggleEvent()
        this.addCloseEvent()

        if (this.hotspotElements.length && window.innerWidth > 768) {
            this.toggleHotspot(this.hotspotElements[0])
        }
    }

    /**
     * interaction events on hotspot icon
     *
     * @private
     */
    addToggleEvent() {
        this.hotspotElements.forEach((hotspot) =>
            hotspot.triggerElement.addEventListener('click', () => this.toggleHotspot(hotspot))
        )
    }

    /**
     * interaction event on close icon
     *
     * @private
     */
    addCloseEvent() {
        this.hotspotElements.forEach((hotspot) =>
            hotspot.closeElement.addEventListener('click', () => this.toggleHotspot(hotspot))
        )
    }

    /**
     * set hotspot as current to open it and/or close last current
     *
     * @private
     */
    toggleHotspot(hotspot) {
        // close current
        if (this.currentHotspot) {
            this.currentHotspot.close()
        }

        // open if not same as before
        if (this.currentHotspot !== hotspot) {
            hotspot.open()
            this.currentHotspot = hotspot
        } else {
            this.currentHotspot = null
        }
    }
}
